import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import ServiziPage from "@/pages/ServiziPage";
import ChiSiamoPage from "@/pages/ChiSiamoPage";
import GalleriaPage from "@/pages/GalleriaPage";
import ContattiPage from "@/pages/ContattiPage";

function App() {
  return (
    <div className="App min-h-screen bg-kairos-black">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/servizi" element={<ServiziPage />} />
          <Route path="/chi-siamo" element={<ChiSiamoPage />} />
          <Route path="/galleria" element={<GalleriaPage />} />
          <Route path="/contatti" element={<ContattiPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
